import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_USER_PERMISSION = "GET_USER_PERMISSION";


export const service = async (data) => {
  const options: object = {
    url: '/Api/Document/GetUserPermission',
    type: "GET",
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_USER_PERMISSION, service, mock);
